import type { ActivityScreen } from "@/data/types";

/**
 * The screen a path is, in M35-CONTRACT 6c.3's words; null for a path that is not one of them
 * (the sign-in, the application form, the calculators). The thread counts these.
 */
export function screenOf(pathname: string, published = false): ActivityScreen | null {
  const p = pathname.replace(/\/+$/, "") || "/";
  if (p === "/") return "home";
  if (p === "/plan") return published ? "plan_published" : "plan";
  if (p === "/plan/numbers") return "numbers";
  if (p === "/plan/policies") return "policies";
  if (p.startsWith("/plan/policy/")) return "policy";
  if (p.startsWith("/plan/illustration/")) return "documents";
  if (p === "/messages") return "messages";
  if (p === "/appointments") return "calls";
  if (p === "/learn/faq") return "faq";
  if (p === "/learn" || p.startsWith("/learn/")) return "learn";
  if (p === "/profile") return "profile";
  return null;
}
